import AddChampionshipAgeGroupRequirements from "./AddChampionshipAgeGroupRequirements";

export default AddChampionshipAgeGroupRequirements;
